export function setCredentials(state, credential){
  state.credential=credential;
}

export function setOwnerAffiliation(state, payload){
  state.ownerAffiliation = payload;
}